import { WEBVIEW_CLOSE } from 'legacy/common/constants/webview';
import { isBounceWebview, postMessageToRN } from 'legacy/common/utils/webview';
import { useFormikContext } from 'formik';
import { useRouter } from 'next/router';
import React from 'react';

import { FaGear, FaCheck } from 'react-icons/fa6';
import { MdOutlineRocketLaunch, MdConfirmationNumber } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

interface ActionBarProps {
  eventId: string;
  shouldRequestToPublish: boolean;
  onClickEventSettings: () => void;
  togglePricingTiersModal: () => void;
}

const ActionBar: React.FC<ActionBarProps> = ({
  eventId,
  shouldRequestToPublish,
  onClickEventSettings,
  togglePricingTiersModal
}) => {
  const router = useRouter();
  const { t } = useTranslation(['events']);
  const { values } = useFormikContext<any>();

  const onClickDoneEditing = () => {
    router.push(`/events/${eventId}`);

    if (isBounceWebview()) {
      postMessageToRN(WEBVIEW_CLOSE);
    }
  };

  return (
    <>
      {/* Only show publish button during draft mode */}
      {values.isDraft &&
        (shouldRequestToPublish ? (
          <button
            type="submit"
            className=" bg-primary-800 py-4 w-full  mb-8 md:mb-4 text-white text-base flex items-center justify-center disabled:opacity-70"
          >
            {t('events:host.requestToPublish')}
          </button>
        ) : (
          <button
            type="submit"
            className=" bg-primary-800 py-4 w-full  mb-8 md:mb-4 text-white text-base flex items-center justify-center disabled:opacity-70"
          >
            {t('events:host.publishEvent')}{' '}
            <MdOutlineRocketLaunch className="ml-2" size={20} />
          </button>
        ))}

      <div className="w-full fixed left-0 bottom-0 bg-white pb-8 z-50 md:pb-4">
        {/* Only show done editing button after the event is published */}
        {values.isDraft === false && (
          <button
            type="button"
            className=" bg-primary-800 py-4 w-full  text-white text-base flex items-center justify-center disabled:opacity-70"
            onClick={onClickDoneEditing}
          >
            {t('events:host.doneEditing')}{' '}
            <FaCheck className="ml-2" size={14} />
          </button>
        )}

        <div className="md:w-[630px] md:mx-auto  flex items-center justify-between pt-4 px-4">
          <div className="md:w-full p-3 rounded-full bg-primary-200 flex items-center justify-center">
            <button
              type="button"
              className="w-full text-primary-700 text-base flex items-center justify-center"
              onClick={onClickEventSettings}
            >
              <FaGear size={20} className="md:mr-2" />
              <span className="hidden md:block">
                {t('events:host.eventSettings')}
              </span>
            </button>
          </div>

          <div className="w-full pl-3">
            <div
              className="bg-primary-200 py-3 rounded-full flex items-center justify-center"
              onClick={togglePricingTiersModal}
            >
              <button
                type="button"
                className="text-primary-700 text-base flex items-center"
              >
                <MdConfirmationNumber size={20} className="mr-2" />
                {t('events:host.pricingTiers')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActionBar;
